import { render, staticRenderFns } from "./CloneJob.vue?vue&type=template&id=c6ce0560&scoped=true&"
import script from "./CloneJob.vue?vue&type=script&lang=js&"
export * from "./CloneJob.vue?vue&type=script&lang=js&"
import style0 from "./CloneJob.vue?vue&type=style&index=0&id=c6ce0560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce0560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6ce0560')) {
      api.createRecord('c6ce0560', component.options)
    } else {
      api.reload('c6ce0560', component.options)
    }
    module.hot.accept("./CloneJob.vue?vue&type=template&id=c6ce0560&scoped=true&", function () {
      api.rerender('c6ce0560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CloneJob.vue"
export default component.exports